import { useNamespace, useTranslation } from '@splitfiesta/i18n';

import { StaticPageLayout } from '@/components/layout/StaticPageLayout';

export function TermsPage() {
  const { t } = useTranslation();
  const pagesLoaded = useNamespace('pages');

  if (!pagesLoaded) {
    return null;
  }

  return (
    <StaticPageLayout
      title={t('pages:terms.title')}
      subtitle={t('pages:terms.subtitle')}
    >
      <div className="prose prose-gray dark:prose-invert max-w-none">
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
          {t('pages:terms.lastUpdated')}: {t('pages:terms.lastUpdatedDate')}
        </p>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:terms.sections.acceptance.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            {t('pages:terms.sections.acceptance.description')}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:terms.sections.service.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            {t('pages:terms.sections.service.description')}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:terms.sections.accounts.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-3">
            {t('pages:terms.sections.accounts.description')}
          </p>
          <ul className="list-disc pl-5 text-gray-600 dark:text-gray-400 space-y-1">
            <li>{t('pages:terms.sections.accounts.items.accuracy')}</li>
            <li>{t('pages:terms.sections.accounts.items.security')}</li>
            <li>{t('pages:terms.sections.accounts.items.age')}</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:terms.sections.usage.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-3">
            {t('pages:terms.sections.usage.description')}
          </p>
          <ul className="list-disc pl-5 text-gray-600 dark:text-gray-400 space-y-1">
            <li>{t('pages:terms.sections.usage.items.lawful')}</li>
            <li>{t('pages:terms.sections.usage.items.noAbuse')}</li>
            <li>{t('pages:terms.sections.usage.items.noHarm')}</li>
            <li>{t('pages:terms.sections.usage.items.noObjectionable')}</li>
            <li>{t('pages:terms.sections.usage.items.fairUse')}</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:terms.sections.content.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            {t('pages:terms.sections.content.description')}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:terms.sections.liability.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            {t('pages:terms.sections.liability.description')}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:terms.sections.changes.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            {t('pages:terms.sections.changes.description')}
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
            {t('pages:terms.sections.contact.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            {t('pages:terms.sections.contact.description')}{' '}
            <a
              href="mailto:hello@splitfiesta.com"
              className="text-orange-600 dark:text-orange-400 hover:underline"
            >
              hello@splitfiesta.com
            </a>
          </p>
        </section>
      </div>
    </StaticPageLayout>
  );
}

export default TermsPage;
